<template>
  <div class="h-full flex flex-col">
    <div class="" style="height: 90vh; max-height: 90vh;">
      <div class="text-2xl mt-4 ml-12 py-1" v-for="item in this.news">
        <!-- <div v-if="item.img" class="md:flex-shrink-0">
          <img v-if="item.img.src" class="rounded-lg md:w-56" :src="item.img.src" :alt="item.img.alt">
          <div v-else class="rounded-lg md:w-56"></div>
        </div> -->
        <div>
          <div class="uppercase tracking-wide text-indigo-600 font-bold" v-html="item.title"></div>
          <div class="mt-1 text-gray-800 w-full overflow-hidden leading-tight" v-html="item.body"></div>
        </div>
      </div>

    </div>
    <div class="footer flex flex-col pr-8 text-right" style="height: 10vh; max-height: 10vh;">
      <div class="source font-bold text-3xl">
        {{this.news[0].source}}
      </div>
      <p class="h-2"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsWall',
  props: ['news'],
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
